module.exports = __webpack_public_path__ + "static/media/cd.f202b187.png";